<section>


    <div class="row py-4">
        <div class="col-12 d-flex justify-content-between px-5">
          <h2 class="text-left text-white px-3 my-4"> Mitigaciones del riesgo</h2>
    
          <div class="d-flex justify-content-center align-items-center mx-3">
            <button
            class="badge rounded-pill btn btn-outline-light mx-2"
            [routerLink]="['/pdg/project/list/view/', id]"
          >
            <i
              class="fa-solid fa-right-from-bracket m-2 fs-6"
              aria-hidden="true"
            ></i>
            <span class="m-2 fs-6">Volver</span>
          </button>
    
          <button
          class="badge rounded-pill btn btn-outline-light mx-2"
          [routerLink]="['/pdg/project',id,idMatrix,'risk','mitigations', 'create']"
        >
        <i class="fa-solid fa-plus m-2 fs-6" aria-hidden="true"></i>
          <span class="m-2 fs-6">Crear mitigacion </span>
        </button>
          </div>
    
    
        </div>
      </div>

      <div class="mx-5">
        <div class="container-fluid">

            <div class="backgroundTable mt-3">
                <table 
                datatable
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="componente-importantes componente-importantes-from-popup">
                    <ng-container *ngIf="projectMitigations.length == 0">
                        <div class="text-center text-white">
                            <h2 class="text-white px-5 mt-5">Sin registros</h2>
                            <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                        </div>
                    </ng-container>
    
              
                    <ng-container *ngIf="projectMitigations.length != 0">
                        <thead>
                            <tr>
                                <th class="text-center text-white">Id</th>
                                <th class="text-center text-white">Descripcion</th>
                                <th class="text-center text-white">Calificacion</th>
                                <th class="text-center text-white">Estado</th>
                                <th class="text-center text-white">Usuario a cargo</th>
                                <th class="text-center text-white">Fecha de acción</th>
                                <th class="text-center text-white">Fecha de mitigación</th>
                                <th class="text-center text-white">Acciones</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr *ngFor="let item of projectMitigations">
    
                                <td class="text-center fs-6">{{item.id}}</td>
                                <td class="text-center fs-6">{{item.description}}</td>
                                <td class="text-center fs-6">
                                    <span
                                    style="width:8rem !important ;"
                                    class="badge rounded-pill text-white font-size-14"
                                    [ngStyle]="{'background-color': item.color}">
                                        {{item.calification}}
                                    </span>
                                </td>
                                <td class="text-center fs-6">
                                    <span
                                    style="width:8rem !important ;"
                                    class="badge rounded-pill text-bg-info text-white font-size-14">
                                        {{item.name}}
                                    </span>
                                </td>
                                <td class="text-center fs-6">
                                    <span
                                    style="width:8rem !important ;"
                                    class="badge rounded-pill text-bg-blue-grey text-white font-size-14">
                                        {{item.username}}
                                    </span>
                                </td>
    
                                <td class="text-center fs-6">{{item.dateAccion}}</td>
                                <td class="text-center fs-6">{{item.dateMitigation}}</td>
                                <td class="text-center">           
                                <div ngbDropdown class="d-inline-block">
                                    <i
                                      class="fa-solid fa-gear fa-xl"
                                      id="dropdownBasic1"
                                      ngbDropdownToggle
                                    ></i>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                      <button (click)="riskEdit(id , idMatrix, item)" ngbDropdownItem>
                                        Editar
                                      </button>
                                      <button (click)="mitigationDelete(item.id)" ngbDropdownItem>Eliminar</button>
                                    </div>
                                  </div>
                                </td>
        
                            </tr>
                            
                        </tbody>
                    </ng-container>
                    
    
    
    
                </table>
    
    
    
            </div>
        </div>
      </div>
 

</section>